<script setup lang="ts">
export interface CardPPVticketProps {
  title: string;
  price: string;
  releaseDate?: string;
  disabled?: boolean;
}

const { t } = useI18n();
const props = defineProps<CardPPVticketProps>();
const emit = defineEmits(["click-buy-ticket"]);

const onClickBuyTicket = () => emit("click-buy-ticket");
</script>

<template>
  <div class="cardPPVticket">
    <div class="cardPPVticket_left">
      <div class="w-14">
        <div class="cardPPVticket_icon">
          <IconTicket />
        </div>
      </div>
      <div class="cardPPVticket_title text-main">
        {{ props.title }}
      </div>
    </div>
    <div class="cardPPVticket_right">
      <div class="cardPPVticket_price text-main uppercase">
        {{ props.price }}
      </div>
      <div v-if="props.releaseDate" class="cardPPVticket_date text-secondary">
        <div class="truncate">
          {{ t("labels.release_date") }}
        </div>
        <p>{{ props.releaseDate }}</p>
      </div>
      <BaseButton
        v-else
        name="buy-ticket"
        class="font-bold text-main text-center truncate text-xs min-w-[6rem] sm:min-w-[9rem] sm:text-base"
        :title="t('button.buy_now')"
        type="primary"
        :disabled="props.disabled"
        @click="onClickBuyTicket()"
      >
        {{ t("button.buy_now") }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss">
.cardPPVticket {
  @apply w-full flex justify-between rounded h-24 mt-6 px-2 sm:px-4;
  background-color: var(--base-tab-filter-tag-popup-bgColor)
}

.cardPPVticket_left {
  @apply flex items-center;

  .cardPPVticket_icon {
    @apply w-12 sm:w-14 h-12 sm:h-14 flex justify-center items-center rounded-full;
    background-color: var(--base-card-bgSecondaryColor);
  }

  .cardPPVticket_title {
    @apply px-2 sm:px-4 line-clamp-2 font-bold text-xs sm:text-base md:text-base max-w-[6rem] sm:max-w-[13rem];
  }
}

.cardPPVticket_right {
  @apply flex justify-end items-center;

  .cardPPVticket_price {
    @apply px-2 sm:px-4 truncate font-bold text-xl sm:text-2xl;
  }

  .cardPPVticket_date {
    @apply min-w-[9rem] py-[0.5rem] text-xs rounded-md flex flex-col items-center justify-center;
    background-color: var(--base-card-bgSecondaryColor);
  }
}
</style>
